import React, { useState } from 'react';
import { readingCopy } from '../../data/readingCopy';
import './ReadingFooter.css';

function shareUrl() {
  return `https://nowtarot.com${window.location.pathname}`;
}

export const ReadingWisdom = ({ lang }) => (
  <p className="rf-wisdom">
    <span aria-hidden="true">🌙 </span>
    {readingCopy(lang).wisdom}
  </p>
);

export const ShareBox = ({ lang }) => {
  const copy = readingCopy(lang);
  const [copied, setCopied] = useState(false);
  const canNativeShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
  const url = shareUrl();
  const encoded = encodeURIComponent(url);
  const text = encodeURIComponent(copy.shareMessage);

  const nativeShare = async () => {
    try {
      await navigator.share({ title: copy.shareSheetTitle, text: copy.shareMessage, url });
    } catch {
      // user dismissed the share sheet
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt(copy.copyPrompt, url);
    }
  };

  return (
    <div className="rf-share">
      <h4 className="rf-share-title">{copy.shareTitle}</h4>
      <p className="rf-share-text">{copy.shareText}</p>
      <div className="rf-share-buttons">
        {canNativeShare && (
          <button type="button" className="rf-share-btn rf-share-primary" onClick={nativeShare}>
            {copy.shareWithFriend}
          </button>
        )}
        <a
          className="rf-share-btn"
          href={`https://wa.me/?text=${text}%20${encoded}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </a>
        <a
          className="rf-share-btn"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encoded}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </a>
        <a
          className="rf-share-btn"
          href={`https://twitter.com/intent/tweet?text=${text}&url=${encoded}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          X
        </a>
        <button type="button" className="rf-share-btn" onClick={copyLink}>
          {copied ? copy.copied : copy.copyLink}
        </button>
      </div>
    </div>
  );
};

const ReadingFooter = () => (
  <div className="reading-footer">
    <ReadingWisdom />
    <ShareBox />
  </div>
);

export default ReadingFooter;
